import React, { useState } from "react";
import api from "../../../auth/api";
import {
  alertConfirm,
  alertError,
  alertSuccess,
} from "../../../components/Alert";
import { useDispatch } from "react-redux";
import { fetchUserList } from "@/slices/userSlice";
import Loader from "@/components/Loader";

const AddUser = ({ userTypes, countryList, genderList }) => {
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    gender: "",
    country: "",
    dateOfBirth: "",
    userType: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const confirm = await alertConfirm(
      "Are you sure you want to add a new user?"
    );
    if (!confirm.isConfirmed) return;
    setIsLoading(true);
    try {
      const resp = await api.post("/account/panel/register", formData);
      alertSuccess("User Added Successfully !");
      setFormData({
        email: "",
        name: "",
        gender: "",
        country: "",
        dateOfBirth: "",
        userType: "",
      });
      dispatch(fetchUserList());
    } catch (error) {
      console.log("this is error", error);
      alertError(error?.response?.data?.errors || "Something Went Wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center bg-gray-100">
      <form
        className="bg-white  rounded-lg p-2 space-y-6 w-full max-w-xl"
        onSubmit={handleSubmit}
      >
        {/* <h2 className="text-2xl font-bold text-gray-800 text-center">
          Add User
        </h2> */}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              className="block text-gray-600 font-medium mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              type="email"
              name="email"
              id="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              placeholder="Enter your email"
            />
          </div>

          <div>
            <label
              className="block text-gray-600 font-medium mb-2"
              htmlFor="name"
            >
              Name
            </label>
            <input
              type="text"
              name="name"
              required
              id="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              placeholder="Enter your name"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              className="block text-gray-600 font-medium mb-2"
              htmlFor="gender"
            >
              Gender
            </label>
            <select
              name="gender"
              id="gender"
              required
              value={formData.gender}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option value="" disabled>
                Select Gender
              </option>
              {genderList?.option_List?.map((m) => {
                return <option value={m.title}>{m.title}</option>;
              })}
            </select>
          </div>

          <div>
            <label
              className="block text-gray-600 font-medium mb-2"
              htmlFor="country"
            >
              Country
            </label>
            <select
              name="country"
              id="country"
              required
              value={formData.country}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option value="" disabled>
                Select Country
              </option>
              {countryList?.result?.map((m) => {
                return <option value={m.title}>{m.title}</option>;
              })}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              className="block text-gray-600 font-medium mb-2"
              htmlFor="dob"
            >
              Date of Birth
            </label>
            <input
              type="date"
              required
              name="dateOfBirth"
              id="dob"
              value={formData.dateOfBirth}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          <div>
            <label
              className="block text-gray-600 font-medium mb-2"
              htmlFor="accessType"
            >
              Access Type
            </label>
            <select
              name="userType"
              id="accessType"
              required
              value={formData.userType}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option value="" disabled>
                Select Access Type
              </option>
              {userTypes?.result?.map((m) => {
                return <option value={m.id}>{m.title}</option>;
              })}
            </select>
          </div>
        </div>

        {isLoading ? (
          <div className="flex justify-center">
            <Loader></Loader>
          </div>
        ) : (
          <button
            type="submit"
            className="w-full bg-[var(--mainCol)] text-white font-medium py-2 rounded-lg hover:bg-blue-800 transition duration-200"
          >
            Submit
          </button>
        )}
      </form>
    </div>
  );
};

export default AddUser;
